// language=GraphQL
export const ALL_RATIO_CONFIGS_QUERY = `query Query {
  ratioConfigs: tenantRatioConfigs {
    id
    adressgruppe
  }
}`

// language=GraphQL
export const SINGLE_RATIO_CONFIG_QUERY = `query Query($id: ID!) {
  ratioConfig: tenantRatioConfig(id: $id) {
    id
    adressgruppe
  }
}`

// language=GraphQL
export const CREATE_RATIO_CONFIG_MUTATION = `
  mutation Mutation($input: CreateTenantRatioConfigInput) {
    ratioConfig: createTenantRatioConfig(input: $input) {
      id
      adressgruppe
    }
  }`

// language=GraphQL
export const UPDATE_RATIO_CONFIG_MUTATION = `
  mutation Mutation($input: UpdateTenantRatioConfigInput) {
    ratioConfig: updateTenantRatioConfig(input: $input) {
      id
      adressgruppe
    }
  }`

// language=GraphQL
export const DELETE_RATIO_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteTenantRatioConfigInput) {
    deleteTenantRatioConfig(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_RATIO_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteTenantRatioConfigInput) {
    forceDeleteTenantRatioConfig(input: $input) {
      success
    }
  }`
// language=GraphQL
export const RATIO_CONFIGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTenants: Boolean = false) {
  groupedDependents: tenantRatioConfigDependents(id: $id) {
    tenants @include(if: $withTenants) {
      id
      name
      slug
      domain
      externalReference
    }
  }
}`
